const PageCodes = {
    HOME: 'wap_10000000', // 首页
    BANNER: 'wap_10010000', // banner
    MY_FLOW: 'wap_10020000', // 我的流量
    PACKAGE_UPGRADE: 'wap_10030000', // 流量升级服务
    ORDERING_PACKAGE: 'wap_10040000', // 可订购套餐
    GAS_PACKAGE: 'wap_10050000', // 流量加油包
    USER_CENTER: 'wap_20000000', // 我的
    MY_ORDER: 'wap_20010000', // 我的订单
    INVOICE: 'wap_20010100', // 申请开票
    MY_DEVICE: 'wap_20020000', // 我的设备
    EXCHANGE: 'wap_20030000', // 套餐兑换
    MY_PACKAGE: 'wap_20040000', // 我的套餐
    INVOICE_HISTORY: 'wap_20050000', // 开票历史
    COUPON: 'wap_20060000' // 优惠卡券
}
export {PageCodes}
